(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article"]) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-odaki-article]');
    if (!root) return;

    var body = root.querySelector('[data-article-title]');
    if (!body) return;

    var pageTitle = (body.getAttribute('data-article-title') || '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
    if (!pageTitle) return;

    body.querySelectorAll('h1, h2').forEach(function (heading) {
      var text = (heading.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
      if (text === pageTitle) {
        heading.classList.add('is-duplicate-title');
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  (function () {
    function bindCollection(root) {
      if (!root || root.dataset.odakiCollectionReady === 'true') return;
      root.dataset.odakiCollectionReady = 'true';

      var sortSelect = root.querySelector('[data-odaki-collection-sort]');
      if (sortSelect) {
        sortSelect.addEventListener('change', function () {
          var url = new URL(window.location.href);
          url.searchParams.set('sort_by', sortSelect.value);
          window.location.assign(url.toString());
        });
      }

      var form = root.querySelector('.odaki-collection__filter-form');
      if (form) {
        form.addEventListener('change', function () {
          form.submit();
        });
      }
    }

    function initAll() {
      document.querySelectorAll('[data-odaki-collection]').forEach(bindCollection);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      var root = event.target && event.target.querySelector
        ? event.target.querySelector('[data-odaki-collection]')
        : null;
      if (root) bindCollection(root);
      else if (event.target && event.target.matches && event.target.matches('[data-odaki-collection]')) {
        bindCollection(event.target);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  (() => {
    const run = () => {
      document.querySelectorAll('[data-odk-clock]').forEach((el) => {
        if (el.dataset.bound) return;
        el.dataset.bound = '1';
        const label = el.dataset.label || '';
        const fmt = new Intl.DateTimeFormat(document.documentElement.lang || 'es', {
          hour: 'numeric',
          minute: '2-digit',
          timeZone: 'America/Mexico_City',
        });
        const tick = () => {
          el.textContent = label.replace('[time]', fmt.format(new Date()));
        };
        tick();
        window.setInterval(tick, 30000);
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
    else run();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["odaki-categories-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initBar(root) {
      if (!root || root.dataset.odakiCatReady === 'true') return;
      root.dataset.odakiCatReady = 'true';

      var items = Array.prototype.slice.call(root.querySelectorAll('[data-odaki-cat-item]'));
      var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');

      function place(item) {
        var panel = item.querySelector('[data-odaki-cat-panel]');
        if (!panel) return;
        panel.style.left = '0px';
        var overflow = panel.getBoundingClientRect().right - (window.innerWidth - 16);
        if (overflow > 0) panel.style.left = -Math.round(overflow) + 'px';
      }

      function setOpen(item, open) {
        var toggle = item.querySelector('[data-odaki-cat-toggle]');
        if (!toggle) return;
        item.classList.toggle('is-open', open);
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open) place(item);
      }

      function closeAll(except) {
        items.forEach(function (item) {
          if (item !== except) setOpen(item, false);
        });
      }

      items.forEach(function (item) {
        var toggle = item.querySelector('[data-odaki-cat-toggle]');
        if (!toggle) return;

        toggle.addEventListener('click', function (event) {
          event.preventDefault();
          var willOpen = !item.classList.contains('is-open');
          closeAll(item);
          setOpen(item, willOpen);
        });

        item.addEventListener('mouseenter', function () {
          if (finePointer.matches) place(item);
        });
        item.addEventListener('focusin', function () {
          place(item);
        });
      });

      document.addEventListener('click', function (event) {
        if (root.contains(event.target)) return;
        closeAll(null);
      });

      document.addEventListener('keydown', function (event) {
        if (event.key !== 'Escape') return;
        var open = items.filter(function (item) { return item.classList.contains('is-open'); })[0];
        if (!open) return;
        closeAll(null);
        var toggle = open.querySelector('[data-odaki-cat-toggle]');
        if (toggle) toggle.focus();
      });

      window.addEventListener('resize', function () {
        items.forEach(function (item) {
          if (item.classList.contains('is-open')) place(item);
        });
      });

    }

    function initAll() {
      document.querySelectorAll('[data-odaki-cat-bar]').forEach(initBar);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      var sectionEl = event.target;
      if (!sectionEl) return;
      if (sectionEl.matches && sectionEl.matches('[data-odaki-cat-bar]')) {
        initBar(sectionEl);
        return;
      }
      var root = sectionEl.querySelector ? sectionEl.querySelector('[data-odaki-cat-bar]') : null;
      if (root) initBar(root);
    });
  })();

  (function () {
    function initBar(root) {
      if (!root || root.dataset.odakiCatmReady === 'true') return;
      root.dataset.odakiCatmReady = 'true';

      var nav = root.querySelector('.odaki-cat-m__nav');
      var trigger = root.querySelector('[data-odaki-catm-trigger]');
      var panel = root.querySelector('[data-odaki-catm-panel]');
      var label = root.querySelector('.odaki-cat-m__label');
      if (!trigger || !panel || !nav) return;

      var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');

      function positionPanel() {
        if (!label) {
          nav.style.setProperty('--odaki-cb-panel-left', '100%');
          return;
        }
        var navRect = nav.getBoundingClientRect();
        var labelRect = label.getBoundingClientRect();
        var left = Math.max(0, Math.round(labelRect.right - navRect.left));
        nav.style.setProperty('--odaki-cb-panel-left', left + 'px');

        var panelRect = panel.getBoundingClientRect();
        var overflowRight = panelRect.right - (window.innerWidth - 16);
        if (overflowRight > 0) {
          left = Math.max(0, Math.round(left - overflowRight));
          nav.style.setProperty('--odaki-cb-panel-left', left + 'px');
        }
      }

      function setOpen(open) {
        root.classList.toggle('is-open', open);
        trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open) positionPanel();
      }

      positionPanel();
      window.addEventListener('resize', positionPanel);
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(positionPanel).catch(function () {});
      }

      trigger.addEventListener('click', function (event) {
        if (finePointer.matches) {
          return;
        }
        event.preventDefault();
        setOpen(!root.classList.contains('is-open'));
      });

      root.addEventListener('mouseenter', positionPanel);

      document.addEventListener('click', function (event) {
        if (!root.classList.contains('is-open')) return;
        if (root.contains(event.target)) return;
        setOpen(false);
      });

      document.addEventListener('keydown', function (event) {
        if (event.key !== 'Escape') return;
        if (!root.classList.contains('is-open')) return;
        setOpen(false);
        trigger.focus();
      });
    }

    function initAll() {
      document.querySelectorAll('[data-odaki-catm]').forEach(initBar);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      var sectionEl = event.target;
      if (!sectionEl) return;
      if (sectionEl.matches && sectionEl.matches('[data-odaki-catm]')) {
        initBar(sectionEl);
        return;
      }
      var root = sectionEl.querySelector ? sectionEl.querySelector('[data-odaki-catm]') : null;
      if (root) initBar(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["odaki-discount-popup"] && !Shopify.designMode) return;
  try {
    
    (function () {
      var DISMISSED_KEY = 'odaki_popup_dismissed';
      var VISITS_KEY = 'odaki_popup_visits';
      var VISITS_COOKIE_DAYS = 365;

      function getCookie(name) {
        var match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
        return match ? decodeURIComponent(match[1]) : null;
      }

      function setCookie(name, value, days) {
        var expires = '';
        if (days) {
          var date = new Date();
          date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
          expires = '; expires=' + date.toUTCString();
        }
        document.cookie = name + '=' + encodeURIComponent(value) + expires + '; path=/; SameSite=Lax';
      }

      function isDismissed() {
        try {
          if (window.localStorage && localStorage.getItem(DISMISSED_KEY) === 'true') return true;
        } catch (e) {}
        return getCookie(DISMISSED_KEY) === 'true';
      }

      // Permanently (well, for `days`) opts the visitor out: only called when
      // they subscribe or explicitly click "No gracias" — not on a plain close.
      function markDismissed(days) {
        try {
          if (window.localStorage) localStorage.setItem(DISMISSED_KEY, 'true');
        } catch (e) {}
        setCookie(DISMISSED_KEY, 'true', days);
      }

      function getVisitCount() {
        var stored = null;
        try {
          if (window.localStorage) stored = localStorage.getItem(VISITS_KEY);
        } catch (e) {}
        if (stored === null) stored = getCookie(VISITS_KEY);
        var count = parseInt(stored, 10);
        return isNaN(count) ? 0 : count;
      }

      // Counts this as a home page visit and returns the updated total.
      function incrementVisitCount() {
        var next = getVisitCount() + 1;
        try {
          if (window.localStorage) localStorage.setItem(VISITS_KEY, String(next));
        } catch (e) {}
        setCookie(VISITS_KEY, String(next), VISITS_COOKIE_DAYS);
        return next;
      }

      function openPopup(popup) {
        popup.hidden = false;
        popup.setAttribute('aria-hidden', 'false');
        requestAnimationFrame(function () {
          popup.classList.add('is-open');
        });
        document.documentElement.classList.add('odaki-popup-lock');
        var input = popup.querySelector('input[type="email"]');
        if (input) {
          setTimeout(function () {
            input.focus();
          }, 350);
        }
      }

      function closePopup(popup) {
        popup.classList.remove('is-open');
        popup.setAttribute('aria-hidden', 'true');
        document.documentElement.classList.remove('odaki-popup-lock');
        setTimeout(function () {
          popup.hidden = true;
        }, 300);
      }

      function copyToClipboard(text) {
        if (window.navigator.clipboard && window.isSecureContext) {
          return window.navigator.clipboard.writeText(text);
        }
        return new Promise(function (resolve, reject) {
          try {
            var textarea = document.createElement('textarea');
            textarea.value = text;
            textarea.style.position = 'fixed';
            textarea.style.opacity = '0';
            document.body.appendChild(textarea);
            textarea.focus();
            textarea.select();
            document.execCommand('copy');
            document.body.removeChild(textarea);
            resolve();
          } catch (e) {
            reject(e);
          }
        });
      }

      function initPopup(popup) {
        if (popup.getAttribute('data-odaki-popup-init') === 'true') return;
        popup.setAttribute('data-odaki-popup-init', 'true');

        // Shopify appends `#<form-id>` (and `?customer_posted=true`) to the
        // redirect URL after a submission, so the browser can jump back to
        // that form. Ours lives inside a fixed, initially-hidden modal — not
        // in the normal page flow — so that automatic jump can land the
        // visitor at an odd scroll position instead of leaving the page
        // untouched. Clean it up immediately so it behaves like any other
        // page load.
        var popupForm = popup.querySelector('.odaki-popup-form');
        if (popupForm && window.location.hash === '#' + popupForm.id) {
          if (window.history && window.history.replaceState) {
            var cleanUrl =
              window.location.pathname + window.location.search.replace(/[?&]customer_posted=true/, '');
            window.history.replaceState(null, '', cleanUrl);
          }
          window.scrollTo(0, 0);
        }

        var days = parseInt(popup.getAttribute('data-cookie-days'), 10) || 14;
        var visitFrequency = parseInt(popup.getAttribute('data-visit-frequency'), 10) || 2;
        if (visitFrequency < 1) visitFrequency = 1;
        var delay = parseFloat(popup.getAttribute('data-delay'));
        delay = isNaN(delay) ? 2 : delay;

        popup.addEventListener('click', function (event) {
          var copyBtn = event.target.closest('[data-odaki-popup-copy]');
          if (copyBtn) {
            var code = copyBtn.getAttribute('data-code') || '';
            copyToClipboard(code)
              .then(function () {
                copyBtn.textContent = copyBtn.getAttribute('data-label-copied') || copyBtn.textContent;
                copyBtn.classList.add('is-copied');
              })
              .catch(function () {})
              .then(function () {
                setTimeout(function () {
                  closePopup(popup);
                }, 900);
              });
            return;
          }

          if (event.target.closest('[data-odaki-popup-dismiss]')) {
            markDismissed(days);
            closePopup(popup);
            return;
          }
          if (event.target.closest('[data-odaki-popup-close]')) {
            closePopup(popup);
          }
        });

        document.addEventListener('keydown', function (event) {
          if (event.key === 'Escape' && popup.classList.contains('is-open')) {
            closePopup(popup);
          }
        });

        // The form submits natively (no preventDefault/fetch): Shopify's
        // invisible bot-protection needs a real browser submission to inject
        // its CAPTCHA token, which a hand-rolled AJAX request can't
        // replicate. We only add a small loading-state nicety here.
        var form = popup.querySelector('.odaki-popup-form');
        if (form) {
          form.addEventListener('submit', function () {
            var submitBtn = form.querySelector('[data-odaki-popup-submit]');
            if (submitBtn) {
              submitBtn.disabled = true;
              submitBtn.textContent = submitBtn.getAttribute('data-label-sending') || submitBtn.textContent;
            }
          });
        }

        // After Shopify redirects back here post-submission, the real
        // `form.posted_successfully?` / `form.errors` Liquid state is baked
        // directly into this render — reflected via the result marker and
        // the (already visible) error message. Show the outcome immediately
        // instead of waiting for the next visit-count cycle.
        var justSucceeded = !!popup.querySelector('[data-odaki-popup-result="success"]');
        var hasVisibleError = !!popup.querySelector('[data-odaki-popup-error]:not([hidden])');

        if (justSucceeded) {
          popup.querySelector('[data-odaki-popup-content]').classList.add('is-success');
          markDismissed(days);
          openPopup(popup);
          return;
        }

        if (hasVisibleError) {
          openPopup(popup);
          return;
        }

        if (!isDismissed()) {
          var visits = incrementVisitCount();
          if (visits % visitFrequency === 0) {
            setTimeout(function () {
              if (!isDismissed()) openPopup(popup);
            }, delay * 1000);
          }
        }
      }

      document.querySelectorAll('[data-odaki-popup]').forEach(initPopup);

      document.addEventListener('shopify:section:load', function (event) {
        var popup = event.target.querySelector('[data-odaki-popup]');
        if (popup) initPopup(popup);
      });

      document.addEventListener('shopify:section:select', function (event) {
        var popup = event.target.querySelector('[data-odaki-popup]');
        if (popup) openPopup(popup);
      });

      document.addEventListener('shopify:section:deselect', function (event) {
        var popup = event.target.querySelector('[data-odaki-popup]');
        if (popup) {
          popup.classList.remove('is-open');
          popup.setAttribute('aria-hidden', 'true');
          document.documentElement.classList.remove('odaki-popup-lock');
          setTimeout(function () {
            popup.hidden = true;
          }, 300);
        }
      });
    })();
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["odaki-limited"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const select = (swatch) => {
      const item = swatch.closest('[data-odk-limited]');
      if (!item) return;
      const index = Number(swatch.dataset.index);
      item.querySelectorAll('[data-odk-limited-swatch]').forEach((s) => {
        const on = s === swatch;
        s.classList.toggle('is-active', on);
        s.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      item.querySelectorAll('[data-odk-limited-frame]').forEach((frame, i) => {
        frame.classList.toggle('is-active', i === index);
      });
      const tile = item.querySelector('[data-odk-limited-tile]');
      if (tile) tile.style.setProperty('--field', swatch.style.getPropertyValue('--swatch'));
      const label = item.querySelector('[data-odk-limited-label]');
      if (label) label.textContent = swatch.dataset.label || '';
      if (swatch.dataset.url) {
        item.querySelectorAll('[data-odk-limited-link]').forEach((a) => {
          a.href = swatch.dataset.url;
        });
      }
    };

    document.addEventListener('click', (event) => {
      const swatch = event.target.closest('[data-odk-limited-swatch]');
      if (swatch) select(swatch);
    });

    /* En pantallas con puntero, pasar sobre el color ya lo muestra */
    if (window.matchMedia('(hover: hover)').matches) {
      document.addEventListener('pointerover', (event) => {
        const swatch = event.target.closest('[data-odk-limited-swatch]');
        if (swatch && !swatch.classList.contains('is-active')) select(swatch);
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["odaki-oferta"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.addEventListener('click', (event) => {
      const open = event.target.closest('[data-odk-oferta-terms-open]');
      if (open) {
        const dialog = open.closest('.odk-oferta').querySelector('[data-odk-oferta-terms]');
        if (dialog && dialog.showModal) dialog.showModal();
        return;
      }
      const close = event.target.closest('[data-odk-oferta-terms-close]');
      if (close) {
        close.closest('dialog').close();
        return;
      }
      if (event.target.matches('[data-odk-oferta-terms]')) event.target.close();
    });
  })();

  (() => {
    const init = (form) => {
      const data = JSON.parse(form.querySelector('[data-odk-oferta-variants]').textContent);
      const go = form.querySelector('[data-odk-oferta-go]');
      const soldout = form.querySelector('[data-odk-oferta-soldout]');
      const sizes = [...form.querySelectorAll('[data-odk-oferta-size]')];
      const colors = [...form.querySelectorAll('[data-odk-oferta-color]')];
      const checked = (list) => (list.find((i) => i.checked) || {}).value;

      const update = () => {
        const color = colors.length ? checked(colors) : '';
        sizes.forEach((input) => {
          input.disabled = !data.some((v) => v.size === input.value && (!colors.length || v.color === color) && v.available);
        });
        if (sizes.length && !sizes.some((i) => i.checked && !i.disabled)) {
          const next = sizes.find((i) => !i.disabled);
          if (next) next.checked = true;
        }
        const size = checked(sizes);
        const match = data.find((v) => v.size === size && (!colors.length || v.color === color) && v.available);
        if (match) go.href = form.dataset.productUrl + '?variant=' + match.id;
        go.toggleAttribute('hidden', !match);
        if (soldout) soldout.hidden = !!match;
      };

      form.addEventListener('change', update);
      update();
    };

    document.querySelectorAll('[data-odk-oferta-form]').forEach(init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["odaki-size-chart"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const parseRange = (value) => {
      const nums = String(value || '').match(/[0-9]+(?:\.[0-9]+)?/g);
      if (!nums) return null;
      const a = parseFloat(nums[0]);
      const b = parseFloat(nums[nums.length - 1]);
      return [Math.min(a, b), Math.max(a, b)];
    };

    const init = (section) => {
      const finder = section.querySelector('[data-size-finder]');
      const table = section.querySelector('.odaki-size-chart__table');
      if (!finder || !table || finder.dataset.bound) return;
      finder.dataset.bound = '1';

      const strings = {};
      const tpl = section.querySelector('[data-size-strings]');
      if (tpl) {
        tpl.content.querySelectorAll('[data-key]').forEach((el) => {
          strings[el.dataset.key] = el.textContent.trim();
        });
      }
      const esc = (s) => String(s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
      const fill = (text, vars) => text.replace(/\[(\w+)\]/g, (_, k) => (vars[k] != null ? vars[k] : ''));

      const keys = ['bust', 'waist', 'hip'];
      const rows = Array.from(table.querySelectorAll('tbody tr')).map((tr) => {
        const cells = tr.querySelectorAll('td');
        return {
          el: tr,
          size: (tr.querySelector('th') || {}).textContent.trim(),
          ranges: { bust: parseRange(cells[0] && cells[0].dataset.sizeValue), waist: parseRange(cells[1] && cells[1].dataset.sizeValue), hip: parseRange(cells[2] && cells[2].dataset.sizeValue) },
        };
      });

      const inputs = Array.from(finder.querySelectorAll('[data-size-input]'));
      const answer = finder.querySelector('[data-size-answer]');
      const why = finder.querySelector('[data-size-why]');
      const unitSwitch = section.querySelector('[data-size-chart-switch]');
      const unitLabels = finder.querySelectorAll('[data-size-unit]');
      const inInches = () => unitSwitch && unitSwitch.getAttribute('aria-checked') === 'true';

      const labelFor = (key) => {
        const input = finder.querySelector('[data-size-input="' + key + '"]');
        const label = input && input.closest('label').querySelector('.odk-size__label');
        return label ? label.textContent.trim().toLowerCase() : key;
      };

      const update = () => {
        unitLabels.forEach((el) => (el.textContent = inInches() ? 'in' : 'cm'));
        const factor = inInches() ? 2.54 : 1;
        const given = {};
        inputs.forEach((input) => {
          const v = parseFloat(String(input.value).replace(',', '.'));
          if (!isNaN(v) && v > 0) given[input.dataset.sizeInput] = v * factor;
        });
        rows.forEach((r) => r.el.classList.remove('is-match'));
        const used = keys.filter((k) => given[k] != null);
        answer.classList.toggle('is-empty', !used.length);
        if (!used.length) {
          answer.textContent = strings.empty || '';
          why.textContent = '';
          return;
        }

        let best = null;
        rows.forEach((row, index) => {
          let off = 0;
          let fits = 0;
          used.forEach((k) => {
            const r = row.ranges[k];
            if (!r) return;
            const v = given[k];
            if (v < r[0]) off += r[0] - v;
            else if (v > r[1]) off += v - r[1];
            else fits += 1;
          });
          if (!best || off < best.off || (off === best.off && fits > best.fits)) best = { row, index, off, fits };
        });
        if (!best) return;

        best.row.el.classList.add('is-match');
        const size = esc(best.row.size);
        if (best.off === 0) {
          answer.innerHTML = fill(strings.answer || '[size]', { size: '<strong>' + size + '</strong>' });
          const names = used.map(labelFor);
          const list = window.Intl && Intl.ListFormat ? new Intl.ListFormat(document.documentElement.lang || 'es', { type: 'conjunction' }).format(names) : names.join(', ');
          why.textContent = fill(strings.fits || '', { measures: list });
        } else {
          const next = rows[best.index + 1];
          if (next && best.off < 6) {
            answer.innerHTML = fill(strings.between || '[size]', { size: '<strong>' + size + '</strong>', next: '<strong>' + esc(next.size) + '</strong>' });
          } else {
            answer.innerHTML = fill(strings.answer || '[size]', { size: '<strong>' + size + '</strong>' });
          }
          why.textContent = strings.outside || '';
        }
      };

      inputs.forEach((input) => input.addEventListener('input', update));
      if (unitSwitch) unitSwitch.addEventListener('click', () => window.setTimeout(update, 0));
    };

    const boot = (scope) => scope.querySelectorAll('.odk-size').forEach(init);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => boot(document));
    } else {
      boot(document);
    }
    document.addEventListener('shopify:section:load', (e) => boot(e.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["odk-gempages-canvas"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.getElementById('shopify-section-{{ section.id }}');
    if (!root) return;

    root.querySelectorAll('[data-odk-native-atc]').forEach(function (form) {
      if (form.dataset.odkNativeBound === 'true') return;
      form.dataset.odkNativeBound = 'true';

      form.addEventListener('submit', function (event) {
        event.preventDefault();
        var btn = form.querySelector('.odk-native-btn');
        if (!btn || btn.disabled) return;

        var original = btn.textContent.trim();
        btn.disabled = true;
        btn.textContent = '…';

        var rootPath = '/';
        if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
          rootPath = window.Shopify.routes.root;
        }

        fetch(rootPath + 'cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form)
        })
          .then(function (res) {
            if (!res.ok) throw new Error('failed');
            return fetch(rootPath + 'cart.js');
          })
          .then(function (res) {
            if (!res) return null;
            return res.json();
          })
          .then(function (cart) {
            if (cart) {
              document.dispatchEvent(new CustomEvent('cart:updated', { detail: { item_count: cart.item_count } }));
              document.querySelectorAll('[data-count]').forEach(function (el) {
                el.textContent = cart.item_count;
                el.dataset.count = cart.item_count;
              });
            }
            btn.textContent = '✓';
          })
          .catch(function () {
            btn.textContent = '!';
          })
          .finally(function () {
            setTimeout(function () {
              btn.textContent = original;
              btn.disabled = false;
            }, 1600);
          });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (!customElements.get('product-recommendations')) {
      customElements.define('product-recommendations', class ProductRecommendations extends HTMLElement {
        connectedCallback() {
          if (this.dataset.loaded === 'true') return;
          if (this.querySelector('.pi-complementary__list')) {
            this.dataset.loaded = 'true';
            return;
          }
          var url = this.dataset.url + '&section_id=' + this.dataset.sectionId + '&product_id=' + this.dataset.productId;
          fetch(url)
            .then(function (response) { return response.text(); })
            .then(function (html) {
              var doc = new DOMParser().parseFromString(html, 'text/html');
              var source = doc.querySelector('product-recommendations[data-product-id="' + this.dataset.productId + '"]');
              if (source && source.innerHTML.trim().length) {
                this.innerHTML = source.innerHTML;
                this.dataset.loaded = 'true';
              }
            }.bind(this))
            .catch(function () {});
        }
      });
    }

    var section = document.querySelector('product-info[data-section]');
    if (!section) return;

    var swatchOnlyGallery = section.querySelector('[data-pi-swatch-only-gallery]');
    var colorCollage = section.querySelector('[data-pi-color-collage]');
    var optionsRoot = section.querySelector('[data-pi-options]');

    function getOdakiColorOrder() {
      if (optionsRoot && optionsRoot.dataset.piMallaProduct === 'true') {
        return ['negro', 'blanco', 'rosa', 'nude', 'salmon'];
      }
      if (optionsRoot && optionsRoot.dataset.piUnitardo === 'true') {
        return ['negro', 'blanco', 'rosa', 'nude', 'lila', 'marino'];
      }
      if (optionsRoot && optionsRoot.dataset.piLeotardoDucrox === 'true') {
        return ['azul-cielo', 'violeta'];
      }
      return ['negro', 'blanco', 'rosa', 'nude', 'lila'];
    }

    var root = section.querySelector('[data-pi-form]');
    var jsonEl = section.querySelector('[data-pi-json]');
    if (!root || !jsonEl) return;

    var product = JSON.parse(jsonEl.textContent);
    var mediaColorMap = null;

    /* `product | json` trae como máximo 250 variantes; las demás se piden al elegirlas */
    var variantsTotal = parseInt(jsonEl.dataset.variantsCount, 10) || product.variants.length;
    var variantsPartial = variantsTotal > product.variants.length;
    var optionValueIds = {};
    try {
      var optionIdsEl = section.querySelector('[data-pi-option-value-ids]');
      if (optionIdsEl) optionValueIds = JSON.parse(optionIdsEl.textContent);
    } catch (error) {}

    function addVariant(variant) {
      if (!variant || !variant.id) return null;
      var existing = product.variants.find(function (item) {
        return item.id === variant.id;
      });
      if (existing) return existing;
      product.variants.push(variant);
      return variant;
    }

    try {
      var selectedVariantEl = section.querySelector('[data-pi-selected-variant]');
      if (selectedVariantEl) addVariant(JSON.parse(selectedVariantEl.textContent));
    } catch (error) {}

    function handleizeColor(value) {
      if (!value) return '';
      return value
        .toString()
        .toLowerCase()
        .trim()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');
    }

    /* Espejo de snippets/odaki-color-es-handle.liquid: en inglés Shopify muestra "purple", "wine"…
       y los grupos de color y las etiquetas de las fotos están en español. */
    var colorEnToEs = {
      'black': 'negro', 'white': 'blanco', 'red': 'rojo', 'rose': 'rosa', 'pink': 'rosa',
      'purple': 'morado', 'violet': 'violeta', 'gray': 'gris', 'grey': 'gris',
      'wine': 'vino', 'burgundy': 'vino', 'maroon': 'vino',
      'petroleum-blue': 'azul-petroleo', 'petrol-blue': 'azul-petroleo', 'teal': 'azul-petroleo',
      'royal-blue': 'azul-rey', 'cobalt-blue': 'azul-rey',
      'sky-blue': 'azul-cielo', 'light-blue': 'azul-cielo',
      'navy': 'marino', 'navy-blue': 'marino', 'dark-blue': 'marino',
      'turquoise': 'turquesa', 'fuchsia': 'fucsia',
      'rosewood': 'palo-de-rosa', 'dusty-rose': 'palo-de-rosa', 'dusty-pink': 'palo-de-rosa', 'old-rose': 'palo-de-rosa',
      'orange': 'anaranjado', 'yellow': 'amarillo',
      'ochre': 'ocre', 'ocher': 'ocre', 'mustard': 'ocre',
      'lilac': 'lila', 'lavender': 'lila', 'skin': 'nude',
      'water-green': 'v-agua', 'aqua': 'v-agua', 'aqua-green': 'v-agua', 'mint': 'v-agua',
      'military-green': 'v-militar', 'army-green': 'v-militar', 'olive': 'v-militar', 'olive-green': 'v-militar',
      'x-tone': 'x-tono',
      'assorted-color': 'color-variado', 'assorted-colors': 'color-variado', 'mixed-color': 'color-variado',
      'mixed-colors': 'color-variado', 'various-colors': 'color-variado'
    };

    function canonicalColorHandle(colorValue, odakiGroups) {
      var normalized = handleizeColor(colorValue);
      if (!normalized) return '';
      if (colorEnToEs.hasOwnProperty(normalized)) normalized = colorEnToEs[normalized];
      for (var g = 0; g < odakiGroups.length; g++) {
        var group = odakiGroups[g];
        if (!group) continue;
        var aliases = group.split('|');
        for (var a = 0; a < aliases.length; a++) {
          if (handleizeColor(aliases[a]) === normalized) {
            return handleizeColor(aliases[0]);
          }
        }
      }
      /* Fallback: "Azul marino" → azul-marino should resolve to panel tag "marino". */
      for (var g2 = 0; g2 < odakiGroups.length; g2++) {
        var group2 = odakiGroups[g2];
        if (!group2) continue;
        var primary = handleizeColor(group2.split('|')[0]);
        if (!primary || primary.length < 3) continue;
        if (normalized === primary) return primary;
        if (normalized.indexOf(primary) !== -1) return primary;
      }
      return normalized;
    }

    function getCollageOdakiGroups() {
      var fromOptions = optionsRoot && optionsRoot.dataset.odakiColorGroups
        ? optionsRoot.dataset.odakiColorGroups
        : '';
      var fromCollage = colorCollage && colorCollage.dataset.odakiColorGroups
        ? colorCollage.dataset.odakiColorGroups
        : '';
      var csv = fromOptions || fromCollage || '';
      return csv ? csv.split(',') : [];
    }

    function isAttachedMedia(media) {
      if (!media) return false;
      if (media.preview_image && media.preview_image.attached_to_variant) return true;
      var images = product.images || [];
      for (var i = 0; i < images.length; i++) {
        if (images[i].id === media.id && images[i].attached_to_variant) return true;
      }
      return false;
    }

    function buildColorBlockStarts(colorOptionIndex, odakiGroups) {
      var odakiOrder = getOdakiColorOrder();
      var mediaList = product.media || [];
      var starts = {};

      odakiOrder.forEach(function (handle) {
        var fallbackStart = null;

        product.variants.forEach(function (variant) {
          var rawColor = variant['option' + (colorOptionIndex + 1)];
          if (!rawColor) return;
          if (canonicalColorHandle(rawColor, odakiGroups) !== handle) return;
          var featuredId = variant.featured_media && variant.featured_media.id
            ? variant.featured_media.id
            : (variant.featured_image && variant.featured_image.id ? variant.featured_image.id : null);
          if (!featuredId) return;

          for (var i = 0; i < mediaList.length; i++) {
            if (mediaList[i].id === featuredId) {
              if (fallbackStart === null || i < fallbackStart) fallbackStart = i;
              break;
            }
          }
        });

        if (fallbackStart !== null) starts[handle] = fallbackStart;
      });

      return starts;
    }

    function buildAutoMediaColorMap(colorOptionIndex, odakiGroups) {
      var map = {};
      var mediaList = product.media || [];
      if (!mediaList.length) return { map: map, starts: {} };

      var colorStartIndex = buildColorBlockStarts(colorOptionIndex, odakiGroups);

      product.variants.forEach(function (variant) {
        var rawColor = variant['option' + (colorOptionIndex + 1)];
        if (!rawColor) return;
        var handle = canonicalColorHandle(rawColor, odakiGroups);
        var featuredId = variant.featured_media && variant.featured_media.id
          ? variant.featured_media.id
          : (variant.featured_image && variant.featured_image.id ? variant.featured_image.id : null);
        if (!featuredId) return;
        map[featuredId] = handle;
      });

      var sortedColors = Object.keys(colorStartIndex).sort(function (a, b) {
        return colorStartIndex[a] - colorStartIndex[b];
      });

      for (var mi = 0; mi < mediaList.length; mi++) {
        var media = mediaList[mi];
        if (map[media.id]) continue;
        if (!isAttachedMedia(media)) continue;

        var blockColor = null;
        for (var ci = sortedColors.length - 1; ci >= 0; ci--) {
          var colorHandle = sortedColors[ci];
          if (mi >= colorStartIndex[colorHandle]) {
            blockColor = colorHandle;
            break;
          }
        }
        if (blockColor) map[media.id] = blockColor;
      }

      return { map: map, starts: colorStartIndex };
    }

    function buildMediaColorMap(colorOptionIndex, odakiGroups) {
      var map = {};
      if (colorCollage && colorCollage.dataset.piCollageCustom === 'true') {
        colorCollage.querySelectorAll('[data-pi-collage-panel]').forEach(function (panel) {
          var mediaId = parseInt(panel.dataset.mediaId, 10);
          if (!isNaN(mediaId)) {
            map[mediaId] = panel.dataset.colorTag || '';
          }
        });
        return map;
      }

      return buildAutoMediaColorMap(colorOptionIndex, odakiGroups).map;
    }

    function getAutoCollageMediaIds(colorHandle, colorOptionIndex, odakiGroups) {
      var autoData = buildAutoMediaColorMap(colorOptionIndex, odakiGroups);
      var ids = {};
      var startIdx = autoData.starts[colorHandle];
      if (startIdx !== undefined) {
        var odakiOrder = getOdakiColorOrder();
        var nextStart = product.media.length;
        var colorPos = odakiOrder.indexOf(colorHandle);
        if (colorPos >= 0 && startIdx !== undefined) {
          for (var ni = 0; ni < odakiOrder.length; ni++) {
            if (ni <= colorPos) continue;
            var nextHandle = odakiOrder[ni];
            var nextIdx = autoData.starts[nextHandle];
            if (nextIdx !== undefined && nextIdx > startIdx && (nextIdx - startIdx) >= 3) {
              if (nextIdx < nextStart) nextStart = nextIdx;
            }
          }
        }
        [0, 1, 2].forEach(function (offset) {
          var idx = startIdx + offset;
          if (idx >= nextStart) return;
          if (product.media[idx]) ids[product.media[idx].id] = true;
        });
      }
      return ids;
    }

    function sortCollagePanels(panels) {
      return panels.slice().sort(function (a, b) {
        var slotA = parseInt(a.dataset.collageSlot, 10);
        var slotB = parseInt(b.dataset.collageSlot, 10);
        if (!isNaN(slotA) && !isNaN(slotB)) return slotA - slotB;
        return (parseInt(a.dataset.photoIndex, 10) || 0) - (parseInt(b.dataset.photoIndex, 10) || 0);
      });
    }

    function colorTagsMatch(tag, handle) {
      return handleizeColor(tag) === handleizeColor(handle);
    }

    function findCustomCollagePanels(colorHandle) {
      var matchedPanels = [];
      colorCollage.querySelectorAll('[data-pi-collage-panel]').forEach(function (panel) {
        if (colorTagsMatch(panel.dataset.colorTag || '', colorHandle)) {
          matchedPanels.push(panel);
        }
      });
      return sortCollagePanels(matchedPanels);
    }

    function getCollageVisiblePanels() {
      if (!colorCollage) return [];
      var main = colorCollage.querySelector('[data-pi-collage-main]');
      if (!main) return [];

      var activeColor = colorCollage.dataset.activeColor || '';
      var isCustom = colorCollage.dataset.piCollageCustom === 'true';
      var visible = [];

      main.querySelectorAll('[data-pi-collage-panel]').forEach(function (panel) {
        if (panel.classList.contains('is-hidden') || panel.hidden) return;
        if (isCustom && activeColor && !colorTagsMatch(panel.dataset.colorTag || '', activeColor)) return;
        visible.push(panel);
      });

      return sortCollagePanels(visible);
    }

    function layoutCollageGrid() {
      if (!colorCollage) return;
      var main = colorCollage.querySelector('[data-pi-collage-main]');
      if (!main) return;

      var visible = getCollageVisiblePanels();
      var count = visible.length;
      if (count === 0) return;

      var isCustom = colorCollage.dataset.piCollageCustom === 'true';
      var targetSlots = parseInt(colorCollage.dataset.piCollageSlots, 10) || 0;
      var layoutMode = count;

      if (isCustom && targetSlots >= 2) {
        layoutMode = targetSlots;
      } else if (count === 3 || count === 4 || count === 5) {
        layoutMode = count;
      } else if (isCustom && count >= 2) {
        layoutMode = 3;
      }

      main.className = main.className.replace(/\bis-collage-count-\d+\b/g, '').trim();
      main.classList.add('is-collage-count-' + Math.min(layoutMode, 6));

      if (isCustom && targetSlots === 3) {
        updateCollageMobileNav();
        return;
      }

      if (colorCollage.dataset.piMallaColorGallery === 'true') {
        main.className = main.className.replace(/\bis-collage-count-\d+\b/g, '').trim();
        main.classList.add('is-collage-count-1');
        updateCollageMobileNav();
        return;
      }

      main.querySelectorAll('[data-pi-collage-panel]').forEach(function (panel) {
        panel.classList.remove(
          'is-collage-hero',
          'is-collage-sub',
          'is-collage-sub-1',
          'is-collage-sub-2',
          'is-collage-sub-3',
          'is-collage-sub-4'
        );
      });

      visible.forEach(function (panel, index) {
        if (layoutMode === 3 || layoutMode === 4 || layoutMode === 5) {
          if (index === 0) {
            panel.classList.add('is-collage-hero');
          } else if (index <= 4) {
            panel.classList.add('is-collage-sub', 'is-collage-sub-' + index);
          }
        }
      });

      updateCollageMobileNav();
    }

    function isMobileCollageView() {
      return window.matchMedia('(max-width: 749px)').matches;
    }

    function scrollCollageToStart() {
      if (!colorCollage) return;
      var main = colorCollage.querySelector('[data-pi-collage-main]');
      if (main) main.scrollLeft = 0;
    }

    function updateCollageMobileNav() {
      if (!colorCollage) return;
      var nav = colorCollage.querySelector('[data-pi-collage-mobile-nav]');
      var counter = colorCollage.querySelector('[data-pi-collage-counter]');
      var dotsWrap = colorCollage.querySelector('[data-pi-collage-dots]');
      var main = colorCollage.querySelector('[data-pi-collage-main]');
      if (!nav || !main) return;

      /* En escritorio solo los colores con dos fotos (frente y espalda) van en carrusel */
      var isPairCarousel = main.classList.contains('is-collage-count-2');
      if (!isMobileCollageView() && !isPairCarousel) {
        nav.hidden = true;
        return;
      }

      var visible = getCollageVisiblePanels();
      if (visible.length <= 1) {
        nav.hidden = true;
        return;
      }

      nav.hidden = false;
      if (dotsWrap) {
        dotsWrap.innerHTML = '';
        visible.forEach(function (panel, index) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'product-media__dot' + (index === 0 ? ' is-active' : '');
          dot.setAttribute('aria-label', String(index + 1));
          dot.addEventListener('click', function () {
            main.scrollTo({ left: main.clientWidth * index, behavior: 'smooth' });
          });
          dotsWrap.appendChild(dot);
        });
      }

      var prevArrow = nav.querySelector('[data-pi-collage-prev]');
      var nextArrow = nav.querySelector('[data-pi-collage-next]');

      function syncCollageCounter() {
        if (!counter || !main.clientWidth) return;
        var index = Math.round(main.scrollLeft / main.clientWidth);
        index = Math.max(0, Math.min(index, visible.length - 1));
        counter.textContent = (index + 1) + ' / ' + visible.length;
        if (dotsWrap) {
          dotsWrap.querySelectorAll('.product-media__dot').forEach(function (dot, dotIndex) {
            dot.classList.toggle('is-active', dotIndex === index);
            dot.setAttribute('aria-current', dotIndex === index ? 'true' : 'false');
          });
        }
        if (prevArrow) prevArrow.disabled = index === 0;
        if (nextArrow) nextArrow.disabled = index === visible.length - 1;
      }

      /* El listener se enlaza una vez; siempre usa el conteo del color activo */
      main._piCollageSync = syncCollageCounter;
      if (main.dataset.collageScrollBound !== 'true') {
        main.dataset.collageScrollBound = 'true';
        main.addEventListener('scroll', function () {
          if (main._piCollageSync) main._piCollageSync();
        }, { passive: true });
      }

      if (nav.dataset.collageArrowsBound !== 'true') {
        nav.dataset.collageArrowsBound = 'true';
        [[prevArrow, -1], [nextArrow, 1]].forEach(function (pair) {
          if (!pair[0]) return;
          pair[0].addEventListener('click', function () {
            if (!main.clientWidth) return;
            var total = getCollageVisiblePanels().length;
            var current = Math.round(main.scrollLeft / main.clientWidth);
            var target = Math.max(0, Math.min(current + pair[1], total - 1));
            main.scrollTo({ left: main.clientWidth * target, behavior: 'smooth' });
          });
        });
      }

      syncCollageCounter();
    }

    function setCollageItemVisibility(item, show) {
      item.classList.toggle('is-hidden', !show);
      item.hidden = !show;
    }

    function filterColorCollage(colorValue) {
      if (!colorCollage) return;
      /* "Color variado" no tiene fotos propias: se conserva la galería actual */
      if (/^(color-variado|x-tono|x-tone|variado|colores-variados|assorted-colors?|mixed-colors?|various-colors)$/.test(handleizeColor(colorValue))) return;
      try {
        var colorIdx = parseInt(colorCollage.dataset.colorOptionIndex, 10);
        if (isNaN(colorIdx)) return;

        var odakiGroups = getCollageOdakiGroups();
        var colorHandle = canonicalColorHandle(colorValue, odakiGroups);
        colorCollage.dataset.activeColor = colorHandle;

        var isCustom = colorCollage.dataset.piCollageCustom === 'true';
        var slotLimit = parseInt(colorCollage.dataset.piCollageSlots, 10) || (isCustom ? 3 : 0);

        if (!isCustom) {
          if (!mediaColorMap) {
            mediaColorMap = buildMediaColorMap(colorIdx, odakiGroups);
          }
        }

        if (isCustom) {
          colorCollage.querySelectorAll('[data-pi-collage-panel]').forEach(function (panel) {
            setCollageItemVisibility(panel, colorTagsMatch(panel.dataset.colorTag || '', colorHandle));
          });

          colorCollage.querySelectorAll('[data-pi-collage-thumb]').forEach(function (thumb) {
            setCollageItemVisibility(thumb, colorTagsMatch(thumb.dataset.colorTag || '', colorHandle));
          });
        } else {
          if (!mediaColorMap) {
            mediaColorMap = buildMediaColorMap(colorIdx, odakiGroups);
          }

          colorCollage.querySelectorAll('[data-pi-collage-thumb]').forEach(function (thumb) {
            var mediaId = parseInt(thumb.dataset.mediaId, 10);
            var tag = mediaColorMap[mediaId] || thumb.dataset.colorTag || '';
            setCollageItemVisibility(thumb, colorTagsMatch(tag, colorHandle));
          });

          colorCollage.querySelectorAll('[data-pi-collage-panel]').forEach(function (panel) {
            var mediaId = parseInt(panel.dataset.mediaId, 10);
            var tag = mediaColorMap[mediaId] || panel.dataset.colorTag || '';
            setCollageItemVisibility(panel, colorTagsMatch(tag, colorHandle));
          });
        }

        var visibleCount = getCollageVisiblePanels().length;

        layoutCollageGrid();
        scrollCollageToStart();
        updateCollageMobileNav();
      } catch (error) {
        /* Never block variant picker if collage filter fails */
      }
    }

    window.addEventListener('resize', function () {
      if (colorCollage) {
        layoutCollageGrid();
        updateCollageMobileNav();
      }
    });

    var form = root;
    var variantInput = form.querySelector('[data-pi-variant-id]');
    var installmentInput = section.querySelector('[data-pi-installment-variant]');
    var priceEl = section.querySelector('[data-pi-price]');
    var skuEl = section.querySelector('[data-pi-sku]');
    var inventoryEl = section.querySelector('[data-pi-inventory]');
    var atcButtons = Array.prototype.slice.call(form.querySelectorAll('[data-pi-atc]'));
    var stickyBar = section.querySelector('[data-pi-sticky-cart]');
    var stickyAtc = section.querySelector('[data-pi-sticky-atc]');
    var stickyPrice = section.querySelector('[data-pi-sticky-price]');
    var buyBlock = form.closest('.pi-block--buy');
    var optionButtons = section.querySelectorAll('[data-pi-option]');
    var optionSelects = section.querySelectorAll('[data-pi-option-select]');
    var qtyInput = section.querySelector('[data-pi-qty]');
    var minusBtn = section.querySelector('[data-pi-qty-minus]');
    var plusBtn = section.querySelector('[data-pi-qty-plus]');

    var selectedOptions = [];
    var initialVariantId = variantInput ? parseInt(variantInput.value, 10) : null;
    var initialVariant = product.variants.find(function (variant) {
      return variant.id === initialVariantId;
    });

    if (initialVariant) {
      selectedOptions = [initialVariant.option1, initialVariant.option2, initialVariant.option3].filter(Boolean);
    } else if (product.variants.length) {
      selectedOptions = [product.variants[0].option1, product.variants[0].option2, product.variants[0].option3].filter(Boolean);
    }

    function findVariant() {
      return product.variants.find(function (variant) {
        return selectedOptions.every(function (value, index) {
          return variant['option' + (index + 1)] === value;
        });
      });
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      var n = Number(number);
      var p = precision == null ? 2 : precision;
      var t = thousands == null ? ',' : thousands;
      var d = decimal == null ? '.' : decimal;

      if (!isFinite(n) || !isFinite(p)) return '0';

      var fixed = n.toFixed(p).split('.');
      var dollars = fixed[0].replace(/\B(?=(\d{3})+(?!\d))/g, t);
      var cents = fixed[1] ? d + fixed[1] : '';
      return dollars + cents;
    }

    function formatMoney(cents) {
      var format = section.dataset.moneyFormat || '${{amount}}';
      var value = Number(cents);
      if (!isFinite(value)) value = 0;
      var amount = value / 100;

      return format.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, token) {
        switch (token) {
          case 'amount':
            return formatWithDelimiters(amount, 2, ',', '.');
          case 'amount_no_decimals':
            return formatWithDelimiters(amount, 0, ',', '.');
          case 'amount_with_comma_separator':
            return formatWithDelimiters(amount, 2, '.', ',');
          case 'amount_no_decimals_with_comma_separator':
            return formatWithDelimiters(amount, 0, '.', ',');
          case 'amount_with_apostrophe_separator':
            return formatWithDelimiters(amount, 2, "'", '.');
          case 'amount_with_space_separator':
            return formatWithDelimiters(amount, 2, ' ', ',');
          case 'amount_no_decimals_with_space_separator':
            return formatWithDelimiters(amount, 0, ' ', ',');
          default:
            return formatWithDelimiters(amount, 2, ',', '.');
        }
      });
    }

    function updateInventory(variant) {
      if (!inventoryEl || !variant) return;
      var threshold = parseInt(inventoryEl.dataset.threshold, 10) || 10;
      var showCount = inventoryEl.dataset.showCount === 'true';
      var html = '';
      if (variant.inventory_management !== 'shopify') {
        inventoryEl.classList.add('pi-inventory--hidden');
        return;
      }
      inventoryEl.classList.remove('pi-inventory--hidden');
      if (variant.inventory_quantity > 0) {
        if (variant.inventory_quantity <= threshold) {
          html = '<span class="pi-inventory__dot pi-inventory__dot--low" aria-hidden="true"></span>';
          html += showCount
            ? inventoryEl.dataset.labelLowCount.replace('{{ quantity }}', variant.inventory_quantity)
            : inventoryEl.dataset.labelLow;
        } else {
          html = '<span class="pi-inventory__dot pi-inventory__dot--in" aria-hidden="true"></span>';
          html += showCount
            ? inventoryEl.dataset.labelInCount.replace('{{ quantity }}', variant.inventory_quantity)
            : inventoryEl.dataset.labelIn;
        }
      } else if (variant.inventory_policy === 'continue') {
        html = '<span class="pi-inventory__dot pi-inventory__dot--in" aria-hidden="true"></span>' + inventoryEl.dataset.labelContinue;
      } else {
        html = '<span class="pi-inventory__dot pi-inventory__dot--out" aria-hidden="true"></span>' + inventoryEl.dataset.labelOut;
      }
      inventoryEl.innerHTML = html;
    }

    function updateAvailability() {
      optionButtons.forEach(function (button) {
        var position = parseInt(button.dataset.optionPosition, 10) - 1;
        var testOptions = selectedOptions.slice();
        testOptions[position] = button.dataset.value;
        var match = product.variants.find(function (variant) {
          return testOptions.every(function (opt, index) {
            return variant['option' + (index + 1)] === opt;
          });
        });
        var available = match ? match.available : variantsPartial;
        button.classList.toggle('is-unavailable', !available);
        button.setAttribute('aria-disabled', available ? 'false' : 'true');
      });

      optionSelects.forEach(function (select) {
        var position = parseInt(select.dataset.optionPosition, 10) - 1;
        Array.from(select.options).forEach(function (optionEl) {
          var testOptions = selectedOptions.slice();
          testOptions[position] = optionEl.value;
          var match = product.variants.find(function (variant) {
            return testOptions.every(function (opt, index) {
              return variant['option' + (index + 1)] === opt;
            });
          });
          optionEl.disabled = match ? !match.available : !variantsPartial;
        });
      });
    }

    function updateVariantUI(variant) {
      if (!variant) return;
      variantInput.value = variant.id;
      if (installmentInput) installmentInput.value = variant.id;

      if (priceEl) {
        var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
        var saleLabel = priceEl.dataset.saleLabel || 'Sale';
        priceEl.innerHTML = onSale
          ? '<span class="pi-price__current">' + formatMoney(variant.price) + '</span><s class="pi-price__compare">' + formatMoney(variant.compare_at_price) + '</s><span class="pi-price__badge">' + saleLabel + '</span>'
          : '<span class="pi-price__current">' + formatMoney(variant.price) + '</span>';
      }

      if (skuEl) skuEl.textContent = variant.sku || '';
      if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);
      updateInventory(variant);

      var soldOutLabel = section.dataset.labelSoldOut || 'Sold out';

      atcButtons.forEach(function (btn) {
        var label = btn.querySelector('[data-pi-atc-label]');
        var availableLabel = btn.dataset.labelAvailable || (label && label.textContent) || btn.textContent;
        btn.disabled = !variant.available;
        if (label) label.textContent = variant.available ? availableLabel : soldOutLabel;
      });

      if (stickyAtc) {
        var stickyAvailableLabel = stickyAtc.dataset.labelAvailable || stickyAtc.textContent;
        stickyAtc.disabled = !variant.available;
        stickyAtc.textContent = variant.available ? stickyAvailableLabel : soldOutLabel;
      }

      if (colorCollage) {
        var colorIdx = parseInt(colorCollage.dataset.colorOptionIndex, 10);
        if (!isNaN(colorIdx)) {
          filterColorCollage(variant['option' + (colorIdx + 1)]);
        }
      } else {
        var featuredMediaId = variant.featured_media && variant.featured_media.id
          ? variant.featured_media.id
          : (variant.featured_image && variant.featured_image.id ? variant.featured_image.id : null);
        if (featuredMediaId) {
          var viewer = getMediaViewer();
          var slide = viewer
            ? viewer.querySelector('[data-media-id="' + featuredMediaId + '"]')
            : section.querySelector('[data-media-id="' + featuredMediaId + '"]');
          if (!slide && viewer) {
            slide = viewer.querySelector('[data-pi-slide]');
          }
          if (slide) activateSlide(slide);
        }
      }

      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }

    function getMediaViewer() {
      if (window.matchMedia('(max-width: 749px)').matches) {
        return section.querySelector('[data-pi-viewer-mobile]') || section.querySelector('[data-pi-viewer]');
      }
      return section.querySelector('[data-pi-viewer-desktop]') || section.querySelector('[data-pi-viewer]');
    }

    function getMediaNav() {
      if (window.matchMedia('(max-width: 749px)').matches) {
        return section.querySelector('[data-pi-mobile-nav-mobile]') || section.querySelector('.product-media__mobile-nav');
      }
      return section.querySelector('[data-pi-mobile-nav-desktop]') || section.querySelector('.product-media__mobile-nav');
    }

    function activateSlide(slide, options) {
      var opts = options || {};
      if (!slide) return;

      var mediaId = slide.dataset.mediaId;
      var viewer = getMediaViewer();
      section.querySelectorAll('[data-pi-viewer], [data-pi-viewer-desktop], [data-pi-viewer-mobile]').forEach(function (viewerEl) {
        viewerEl.querySelectorAll('[data-pi-slide]').forEach(function (el) {
          el.classList.toggle('is-active', el.dataset.mediaId === mediaId);
        });
      });

      section.querySelectorAll('[data-pi-thumb]').forEach(function (thumb) {
        var active = thumb.dataset.targetId === mediaId;
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-current', active ? 'true' : 'false');
      });

      var slides = viewer ? viewer.querySelectorAll('[data-pi-slide]') : section.querySelectorAll('[data-pi-slide]');
      var nav = getMediaNav();
      var counter = nav ? nav.querySelector('[data-pi-media-counter]') : section.querySelector('[data-pi-media-counter]');
      var dots = nav ? nav.querySelectorAll('[data-pi-dot]') : section.querySelectorAll('[data-pi-dot]');
      var slideIndex = -1;
      slides.forEach(function (el, index) {
        if (el.dataset.mediaId === mediaId) slideIndex = index;
      });

      if (viewer && slideIndex >= 0 && window.matchMedia('(max-width: 749px)').matches && !opts.skipScroll && !swatchOnlyGallery) {
        viewer.scrollTo({
          left: slideIndex * viewer.clientWidth,
          behavior: opts.instant ? 'auto' : 'smooth'
        });
      }

      if (counter && slides.length && slideIndex >= 0 && !swatchOnlyGallery) {
        counter.textContent = (slideIndex + 1) + ' / ' + slides.length;
      }

      if (!swatchOnlyGallery) {
        dots.forEach(function (dot, index) {
          var active = index === slideIndex;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-current', active ? 'true' : 'false');
        });
      }
    }

    var mediaViewer = getMediaViewer();
    if (mediaViewer && !swatchOnlyGallery) {
      var mediaScrollTimer;
      mediaViewer.addEventListener('scroll', function () {
        if (!window.matchMedia('(max-width: 749px)').matches) return;
        window.clearTimeout(mediaScrollTimer);
        mediaScrollTimer = window.setTimeout(function () {
          var viewer = getMediaViewer();
          if (!viewer) return;
          var slides = viewer.querySelectorAll('[data-pi-slide]');
          var index = Math.round(viewer.scrollLeft / viewer.clientWidth);
          var slide = slides[index];
          if (slide && !slide.classList.contains('is-active')) {
            activateSlide(slide, { skipScroll: true });
          }
        }, 80);
      }, { passive: true });
    }

    if (!swatchOnlyGallery) {
      section.querySelectorAll('[data-pi-dot]').forEach(function (dot) {
        dot.addEventListener('click', function () {
          var viewer = getMediaViewer();
          var slide = viewer
            ? viewer.querySelector('[data-media-id="' + dot.dataset.targetId + '"]')
            : section.querySelector('[data-media-id="' + dot.dataset.targetId + '"]');
          if (slide) activateSlide(slide);
        });
      });
    }

    atcButtons.forEach(function (btn) {
      var label = btn.querySelector('[data-pi-atc-label]');
      btn.dataset.labelAvailable = (label ? label.textContent : btn.textContent).trim();
    });
    if (stickyAtc && !stickyAtc.dataset.labelAvailable) {
      stickyAtc.dataset.labelAvailable = stickyAtc.textContent.trim();
    }

    // "Comprar ahora" buttons (main + sticky bar) add the item to the cart
    // and then jump straight to checkout. Regular "Añadir al carrito"
    // buttons are left alone so the global cart-drawer script (odk-cart.js)
    // can add them via AJAX and open the drawer as usual.
    function buyNowItem(quantity) {
      var item = { id: parseInt(variantInput.value, 10), quantity: quantity };
      var properties = {};
      var hasProperties = false;
      new FormData(form).forEach(function (value, key) {
        var match = /^properties\[(.+)\]$/.exec(key);
        if (match && value !== '') {
          properties[match[1]] = value;
          hasProperties = true;
        }
      });
      if (hasProperties) item.properties = properties;
      return item;
    }

    form.addEventListener('submit', function (event) {
      var submitter = event.submitter;
      if (!submitter || !submitter.hasAttribute('data-pi-buy-now')) return;
      if (!variantInput || !variantInput.value) return;
      event.preventDefault();
      event.stopPropagation();
      var quantity = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
      submitter.disabled = true;
      fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [buyNowItem(quantity)] })
      })
        .then(function (response) { return response.json(); })
        .then(function () {
          window.location.href = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'checkout' : '/checkout';
        })
        .catch(function () {
          submitter.disabled = false;
          form.submit();
        });
    });

    function handleOptionSelect(button) {
      var position = parseInt(button.dataset.optionPosition, 10) - 1;
      selectedOptions[position] = button.dataset.value;
      section.querySelectorAll('[data-pi-option][data-option-position="' + button.dataset.optionPosition + '"]').forEach(function (el) {
        el.classList.remove('is-selected');
        el.setAttribute('aria-pressed', 'false');
      });
      button.classList.add('is-selected');
      button.setAttribute('aria-pressed', 'true');
      var label = section.querySelector('[data-pi-option-value="' + button.dataset.optionPosition + '"]');
      if (label) label.textContent = button.dataset.value;
      updateAvailability();

      if (colorCollage) {
        var collageColorIdx = parseInt(colorCollage.dataset.colorOptionIndex, 10);
        if (!isNaN(collageColorIdx) && position === collageColorIdx) {
          filterColorCollage(button.dataset.value);
        }
      }

      applySelection();
    }

    function showNoVariant() {
      var noVariantSoldOutLabel = section.dataset.labelSoldOut || 'Sold out';
      atcButtons.forEach(function (btn) {
        btn.disabled = true;
        var label = btn.querySelector('[data-pi-atc-label]');
        if (label) label.textContent = noVariantSoldOutLabel;
      });
      if (stickyAtc) {
        stickyAtc.disabled = true;
        stickyAtc.textContent = noVariantSoldOutLabel;
      }
    }

    function setBuyButtonsDisabled(disabled) {
      atcButtons.forEach(function (btn) {
        btn.disabled = disabled;
      });
      if (stickyAtc) stickyAtc.disabled = disabled;
    }

    function selectionKey(options) {
      return options.join('\u0000');
    }

    // Pide a Shopify la variante de la combinación elegida cuando no viene en el JSON
    function fetchVariant(options) {
      var ids = [];
      for (var i = 0; i < options.length; i++) {
        var group = optionValueIds[String(i + 1)] || {};
        if (!group[options[i]]) return Promise.resolve(null);
        ids.push(group[options[i]]);
      }
      var url = new URL(section.dataset.url || window.location.pathname, window.location.origin);
      url.searchParams.set('option_values', ids.join(','));
      url.searchParams.set('section_id', section.dataset.section);
      return fetch(url.toString())
        .then(function (response) { return response.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var el = doc.querySelector('[data-pi-selected-variant]');
          if (!el) return null;
          var variant = JSON.parse(el.textContent);
          var matches = variant && options.every(function (value, index) {
            return variant['option' + (index + 1)] === value;
          });
          return matches ? addVariant(variant) : null;
        })
        .catch(function () { return null; });
    }

    function applySelection() {
      var variant = findVariant();
      if (variant) {
        updateVariantUI(variant);
        return;
      }
      if (!variantsPartial) {
        showNoVariant();
        return;
      }
      var requested = selectedOptions.slice();
      setBuyButtonsDisabled(true);
      fetchVariant(requested).then(function (fetched) {
        if (selectionKey(selectedOptions) !== selectionKey(requested)) return;
        if (fetched) {
          updateAvailability();
          updateVariantUI(fetched);
        } else {
          showNoVariant();
        }
      });
    }

    if (optionsRoot) {
      optionsRoot.addEventListener('click', function (event) {
        var button = event.target.closest('[data-pi-option]');
        if (!button || !optionsRoot.contains(button)) return;
        handleOptionSelect(button);
      });
    } else {
      optionButtons.forEach(function (button) {
        button.addEventListener('click', function () {
          handleOptionSelect(button);
        });
      });
    }

    optionSelects.forEach(function (select) {
      select.addEventListener('change', function () {
        var position = parseInt(select.dataset.optionPosition, 10) - 1;
        selectedOptions[position] = select.value;
        var label = section.querySelector('[data-pi-option-value="' + select.dataset.optionPosition + '"]');
        if (label) label.textContent = select.value;
        updateAvailability();

        if (colorCollage) {
          var collageColorIdx = parseInt(colorCollage.dataset.colorOptionIndex, 10);
          if (!isNaN(collageColorIdx) && position === collageColorIdx) {
            filterColorCollage(select.value);
          }
        }

        applySelection();
      });
    });

    section.querySelectorAll('[data-pi-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var slide = section.querySelector('[data-media-id="' + thumb.dataset.targetId + '"]');
        if (slide) activateSlide(slide);
      });
    });

    var lightbox = section.querySelector('[data-pi-lightbox]');
    if (lightbox) {
      var lightboxContent = lightbox.querySelector('[data-pi-lightbox-content]');
      var lightboxZoomBtn = lightbox.querySelector('[data-pi-lightbox-zoom]');

      function resetLightboxZoom() {
        if (!lightboxContent) return;
        var img = lightboxContent.querySelector('img');
        if (img) img.classList.remove('is-zoomed');
        if (lightboxZoomBtn) lightboxZoomBtn.setAttribute('aria-pressed', 'false');
      }

      function setLightboxZoom(on) {
        if (!lightboxContent) return;
        var img = lightboxContent.querySelector('img');
        if (!img) return;
        img.classList.toggle('is-zoomed', on);
        if (lightboxZoomBtn) lightboxZoomBtn.setAttribute('aria-pressed', on ? 'true' : 'false');
      }

      function openLightbox(src, alt) {
        if (!lightboxContent || !src) return;
        lightboxContent.innerHTML = '';
        var img = document.createElement('img');
        img.src = src;
        img.alt = alt || '';
        img.addEventListener('click', function () {
          setLightboxZoom(!img.classList.contains('is-zoomed'));
        });
        lightboxContent.appendChild(img);
        resetLightboxZoom();
        if (lightbox.showModal) lightbox.showModal();
      }

      section.querySelectorAll('[data-pi-zoom-open]').forEach(function (trigger) {
        trigger.addEventListener('click', function () {
          var img = trigger.querySelector('img');
          var src = trigger.dataset.fullSrc || (img && (img.currentSrc || img.src));
          var alt = img ? img.alt : '';
          openLightbox(src, alt);
        });
      });

      if (lightboxZoomBtn) {
        lightboxZoomBtn.addEventListener('click', function (event) {
          event.stopPropagation();
          var img = lightboxContent && lightboxContent.querySelector('img');
          if (!img) return;
          setLightboxZoom(!img.classList.contains('is-zoomed'));
        });
      }

      lightbox.addEventListener('click', function (event) {
        if (event.target === lightbox) {
          lightbox.close();
        }
      });

      lightbox.addEventListener('cancel', resetLightboxZoom);
      lightbox.addEventListener('close', resetLightboxZoom);

      section.querySelector('[data-pi-lightbox-close]') && section.querySelector('[data-pi-lightbox-close]').addEventListener('click', function () {
        lightbox.close();
      });
    }

    section.querySelectorAll('[data-pi-popup-open]').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var modal = section.querySelector('#PopupModal-' + trigger.dataset.piPopupOpen);
        if (modal && modal.showModal) modal.showModal();
      });
    });

    section.querySelectorAll('[data-pi-popup-close]').forEach(function (button) {
      button.addEventListener('click', function () {
        var modal = button.closest('dialog');
        if (modal) modal.close();
      });
    });

    var shareBtn = section.querySelector('[data-pi-share]');
    if (shareBtn) {
      shareBtn.addEventListener('click', function () {
        if (navigator.share) {
          navigator.share({ title: document.title, url: window.location.href });
        } else if (navigator.clipboard) {
          navigator.clipboard.writeText(window.location.href);
        }
      });
    }

    if (minusBtn && qtyInput) {
      minusBtn.addEventListener('click', function () {
        qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1);
      });
    }
    if (plusBtn && qtyInput) {
      plusBtn.addEventListener('click', function () {
        qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + 1;
      });
    }

    if (stickyBar && buyBlock) {
      stickyBar.hidden = false;
      var stickyObserver = new IntersectionObserver(function (entries) {
        var visible = !entries[0].isIntersecting;
        stickyBar.classList.toggle('is-visible', visible);
      }, { threshold: 0 });
      stickyObserver.observe(buyBlock);
    }

    function ensureAllowedColorSelected() {
      if (!optionsRoot || !initialVariant) return;
      var colorPos = optionsRoot.dataset.colorOptionPosition;
      if (!colorPos) return;
      var currentColor = initialVariant['option' + colorPos];
      if (!currentColor) return;
      var swatches = optionsRoot.querySelectorAll('[data-pi-option][data-option-position="' + colorPos + '"]');
      if (!swatches.length) return;
      var isAllowed = false;
      swatches.forEach(function (btn) {
        if (btn.dataset.value === currentColor) isAllowed = true;
      });
      if (!isAllowed) handleOptionSelect(swatches[0]);
    }

    function ensureAllowedSizeSelected() {
      if (!optionsRoot || !initialVariant) return;
      var sizePos = null;
      optionsRoot.querySelectorAll('.pi-option[data-option-position]').forEach(function (fieldset) {
        var label = fieldset.querySelector('.pi-option__label');
        var name = label ? label.textContent.toLowerCase() : '';
        if (name.indexOf('talla') !== -1 || name.indexOf('size') !== -1) {
          sizePos = fieldset.dataset.optionPosition;
        }
      });
      if (!sizePos) return;
      var currentSize = initialVariant['option' + sizePos];
      if (!currentSize) return;
      var pills = optionsRoot.querySelectorAll('[data-pi-option][data-option-position="' + sizePos + '"]');
      if (!pills.length) return;
      var isAllowed = false;
      var firstPill = null;
      pills.forEach(function (btn) {
        if (!firstPill) firstPill = btn;
        if (String(btn.dataset.value || '').toUpperCase() === String(currentSize).toUpperCase()) {
          isAllowed = true;
        }
      });
      if (!isAllowed && firstPill) handleOptionSelect(firstPill);
    }

    function preferNegroDefaultColor() {
      if (!optionsRoot) return;

      // Keep deep links to a specific variant.
      try {
        if (new URLSearchParams(window.location.search).has('variant')) return;
      } catch (e) {}

      var colorPos = optionsRoot.dataset.colorOptionPosition;
      if (!colorPos) return;

      var negroButton = null;
      optionsRoot.querySelectorAll('[data-pi-option][data-option-position="' + colorPos + '"]').forEach(function (btn) {
        var handle = handleizeColor(btn.dataset.value || '');
        if (handle === 'negro' || handle === 'black') {
          negroButton = btn;
        }
      });

      if (negroButton && !negroButton.classList.contains('is-selected')) {
        handleOptionSelect(negroButton);
      }
    }

    ensureAllowedColorSelected();
    ensureAllowedSizeSelected();
    preferNegroDefaultColor();
    updateAvailability();

    if (colorCollage) {
      layoutCollageGrid();
      updateCollageMobileNav();
    } else {
      var activeSlide = section.querySelector('[data-pi-slide].is-active');
      if (activeSlide) {
        activateSlide(activeSlide, { skipScroll: true, instant: true });
      }
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
